import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance";

export const roleUpdate = ({
  roleId,
  permissions,
  title,
  description
}: {
  roleId: string,
  permissions: string[],
  title: string,
  description: string
}) => {

  const queryParams = {
    permissions,
    title,
    description
  };

  return axiosPrivate.post(`/dashboard/v1/roles/${roleId}/role_update`, queryParams);
};